module.exports = __webpack_public_path__ + "img/dataDetailExampleUs.30440c9b.png";